import { getMallList } from 'app/api/mall';
import { getLiabilityReport } from 'app/api/report';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useGraphAnalylitics = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const navigate = useNavigate();
  const [values, setValues] = useState({
    mallId: '',
    startDate: null,
    endDate: null,
  });
  const [totalNumber, setTotalNumber] = useState(0);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const currentPage = 1;
  const dataPerPage = 10;
  const [mallList, setMallList] = useState([]);
  
  
  const sectionObj = {
    sectionTitle: 'Liability Report',
 
    downloadObj: {
      excelClick: (e) => {
        handleDownloadexcel(e);
      },
      csvClick: (e) => {
        handleDownloadcsv(e);
      },

      pdfClick: () => () => {},
    },
  };

  useEffect(() => {
    getMallListforDropdown();
  }, []);

  const getMallListforDropdown = async () => {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      temp.unshift({ value: '', label: 'All Mall' });
      setMallList([...temp]);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  };

  const fetchReportData = useCallback(
    async (page, search = '', filters = {}) => {
      if(!filters.mallId || !filters.startDate || !filters.endDate ){
        return;
      }
      setPageLoading(true);
      try {
        let requestParams = {
          page,
          limit: dataPerPage,
          search,
          mallId: filters.mallId,
          startDate: filters.startDate,
          endDate: filters.endDate,
        };

        const response = await getLiabilityReport(requestParams);
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.data || [];
          const newArray = dataArr.map((item) => ({
            ...item,
          }));
          setData(newArray);
          setFilteredData(newArray);
          const totalCount = response?.data?.count || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );
 
  function handleSubmit(event) {
    event.preventDefault();
   // setIsFiltering(true);
    fetchReportData(1, '', values);
  }


  async function handleDownloadcsv() {
    if (pageLoading) return;
    setPageLoading(true);
    try {
    let downloadType = 'csv';
    let download = true;
    let page = 1;
    let dataPerPage = totalNumber;
    let filters = values;
    let requestParams = {
      page,
      limit: dataPerPage,
      mallId: filters.mallId,
      startDate:filters.startDate,
      endDate:filters.endDate,
      download,
      downloadType,
    };
    const response = await getLiabilityReport(requestParams);

    if (response?.responseCode === 200) {
      const link = document.createElement('a');
      link.href = response.data; // Replace with your file URL
      link.target = '_blank'; // Open in a new tab
      link.click();
    } else {
      Toast.error(response?.response?.message || Message.Error.COMMON_MESSAGE);
    }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      setPageLoading(false);
    }
  }
  async function handleDownloadexcel() {
    if (pageLoading) return;
    setPageLoading(true);
    try {
    let downloadType = 'excel';
    let download = true;
    let page = 1;
    let dataPerPage = totalNumber;

    let filters = values;
    let requestParams = {
      page,
      limit: dataPerPage,
      mallId: filters.mallId,
      startDate:filters.startDate,
      endDate:filters.endDate,
      download,
      downloadType,
    };

    const response = await getLiabilityReport(requestParams);

    if (response?.responseCode === 200) {
      const link = document.createElement('a');
      link.href = response.data; // Replace with your file URL
      link.target = '_blank'; // Open in a new tab
      link.click();
    } else {
      Toast.error(response?.response?.message || Message.Error.COMMON_MESSAGE);
    }
    } catch (error) {
      Toast.error(Message.Error.COMMON_MESSAGE);
    } finally {
      setPageLoading(false);
    }
  }
  function setChange(e) {
   const { name, value} = e.target
    setValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    
  }
  function setChangegetvalue(e) {
    const { name, value} = e.target
     setValues((prevState) => ({
       ...prevState,
       [name]: value,
     }));

   }
  
  return {
    pageLoading,
    filteredData,
    fetchReportData,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    handleSubmit,
    mallList,
    setChange,
    setChangegetvalue
  };
};

export default useGraphAnalylitics;
